import { useEffect } from 'react'

import { ScanResult } from '@eastcoal/api/auth/interface'

import { useFeedback } from '@eastcoal/common/hooks/useFeedback'
import { browserRedirect, browserReload } from '@eastcoal/common/utils/browser'
import { pick } from '@eastcoal/common/utils/object'

import { useSearchParams } from '@eastcoal/router/exports/react-router'

import { ScanQrcode } from '../../ScanQrcode'
import { useRegisterStore } from '../hooks/useStore'

export const RegisterQrcode = () => {
  const { modal } = useFeedback()
  const { setOpenId } = useRegisterStore(state => pick(state, ['setOpenId']))

  const [params] = useSearchParams()
  const openId = params.get('openId')

  useEffect(() => {
    if (openId) {
      setOpenId(openId)
    }
  }, [openId, setOpenId])

  const handleScan = ({ bound, openId }: ScanResult) => {
    if (bound) {
      browserRedirect('/')
    } else if (openId) {
      setOpenId(openId)
    } else {
      modal.confirm({
        title: '获取扫描结果失败',
        content: '请问是否刷新页面重试？',
        okText: '刷新页面',
        onOk() {
          browserReload()
        }
      })
    }
  }
  return <ScanQrcode autoLogin onScan={handleScan} />
}
